import React from "react";
import { STRINGS } from "../../../strings";
import { globalize, translate } from "../../../translate";
import { AppCard, AppCardContent } from "../../Generic/AppCard";
import { AppIcon } from "../../Generic/AppIcon";
import { AppListItem } from "../../Generic/AppList";
import ScaffoldTitle from "../../Scaffold/components/ScaffoldTitle";
import Scaffold from "../../Scaffold/Scaffold";
import { CHEVRON_RIGHT_ICON, DOCUMENT_DOLLAR } from "../../../utils/svgs_new";
import { Paystub } from "../../../messages/Paystub";
import Flex from "../../Generic/Flex";
import styled from "@emotion/styled";
import MonthPicker from "../../MonthPicker/MonthPicker";
import { Month } from "@js-joda/core";
import { If } from "../../Generic/If";
import LoadingBar from "../../Generic/LoadingBar";
import { motion } from "framer-motion";

interface Props {
  paystubs: Paystub[];
  onClickGoBack: () => void;
  onClickPaystub: (paystub: Paystub) => void;
  isFetching: boolean;
  scheduleYear: number;
  scheduleMonth: Month;
  onClickPreviousScheduleMonth: () => any;
  onlickNextScheduleMonth: () => any;
  onChangeScheduleMonth: (year: number, month: number) => void;
}

const PaystubListScreen = (props: Props) => {
  const paystubForText = translate(STRINGS.PAYSTUB);

  const extraHeader = (
    <MonthPicker
      year={props.scheduleYear}
      month={props.scheduleMonth}
      onClickPrevious={props.onClickPreviousScheduleMonth}
      onClickNext={props.onlickNextScheduleMonth}
      onChange={props.onChangeScheduleMonth}
    />
  );

  return (
    <Scaffold
      title={<ScaffoldTitle label={translate(STRINGS.PAYROLL)} />}
      onClickGoBack={props.onClickGoBack}
      extraHeader={extraHeader}
    >
      <If condition={props.isFetching}>
        <LoadingBar />
      </If>
      <If condition={props.paystubs.length === 0}>
        <motion.div
          key="no-paystubs-found"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <NoPaystubsContainer>
            {`${translate(STRINGS.NO_PAYSTUBS_FOUND_FOR_THIS_MONTH)}`}
          </NoPaystubsContainer>
        </motion.div>
      </If>
      <PaystubListWrapper>
        {props.paystubs.map((paystub) => {
          const periodBeginText = globalize().formatLocalDate(paystub.periodBeginDate);
          const periodEndText = globalize().formatLocalDate(paystub.periodEndDate);
          return (
            <PaystubCard
              key={paystub.checkDate.toString()}
              onClick={() => props.onClickPaystub(paystub)}
            >
              <AppCardContent>
                <Flex justifyContent="space-between">
                  <AppListItem
                    leading={<AppIcon icon={DOCUMENT_DOLLAR} />}
                    title={`${paystubForText} ${periodBeginText} - ${periodEndText}`}
                    onClick={() => props.onClickPaystub(paystub)}
                  />
                  <AppIcon icon={CHEVRON_RIGHT_ICON} />
                </Flex>
              </AppCardContent>
            </PaystubCard>
          );
        })}
      </PaystubListWrapper>
    </Scaffold>
  );
};

const PaystubListWrapper = styled.div`
    margin: 8px
    display: flex
    flex-direction: column
    justify-content: space-between
    gap: 8px
`;

const PaystubCard = styled(AppCard)`
  margin: 10px;
`;

const NoPaystubsContainer = styled.div`
  text-align: center;
  padding: 16px;
  color: var(--tw-slate-500);
`;

export default PaystubListScreen;
